import { useEffect } from 'react'
import { initNetworkStatusListeners } from '../../helpers/networkStatus.helper'
import { OfflineBanner } from '../OfflineBanner/OfflineBanner'

export function NetworkStatusHost() {
  useEffect(() => initNetworkStatusListeners(), [])

  return <OfflineBanner />
}
